import React, { useState, useRef, useEffect } from "react";
import PersonIcon from "@mui/icons-material/Person";
import ExpandMoreIcon from "@mui/icons-material/ExpandMore";
import ExpandLessIcon from "@mui/icons-material/ExpandLess";
import ExitToAppIcon from "@mui/icons-material/ExitToApp";
import Badge from "@mui/material/Badge";
import MessageIcon from "@mui/icons-material/Message";
import { useNavigate } from "react-router-dom";
import { Auth } from "aws-amplify";
import { jwtDecode } from "jwt-decode";
import { useLoading } from "../../../../context/LoadingContext";
import { getParameterFromManager } from "../../../../services/Utils";
import AlertModal from "../../../Requirement/components/common/AlerModel";
import { fetchData } from "../../../Requirement/services/RequirementServices";
import { NotificationCenter } from "../../../../components/common/notifications";

const Header = ({ clientmenu, homemenu, procurementmenu }) => {
  const navigate = useNavigate();
  const [activeUser, setActiveUser] = useState("");
  const dropdownRef = useRef(null);
  const [isDropdownVisible, setIsDropdownVisible] = useState(false);
  const [userMessageCount, setUserMessageCount] = useState(0); // Initialize to 0 instead of null
  const [isProfileDropdownVisible, setIsProfileDropdownVisible] =
    useState(false);
  const [isNotificationDropdownVisible, setIsNotificationDropdownVisible] =
    useState(false);
  const [isArrowDown, setIsArrowDown] = useState(true);
  const [userInfo, setUserInfo] = useState(null);
  const { setLoading } = useLoading();
  const [INRToUsd, setINRToUSD] = useState(0.012);
  const [modal, setModal] = useState({
    show: false,
    type: "info",
    title: "",
    message: "",
    nextAction: null,
  });

  const Signout = async () => {
    console.log("rrrrrrrrrr");
    setLoading(true);
    try {
      localStorage.clear();
      navigate("/login/amtpl");
    } catch (error) {
      console.error("Error signing out: ", error);
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    const checkUser = async () => {
      try {
        const user = await Auth.currentAuthenticatedUser();
        const token = user.signInUserSession.idToken.jwtToken;
        const decodedToken = jwtDecode(token);

        const groups = decodedToken["cognito:groups"] || [];
        if (!groups.includes("AMTPL_ADMINS")) {
          await Auth.signOut();
          navigate("/amtpla");
        } else {
          setActiveUser(user.attributes.email);
        }
        let inrToUsdVal = await getParameterFromManager("INR_TO_USD");
        inrToUsdVal = parseFloat(inrToUsdVal);
        setINRToUSD(inrToUsdVal);
      } catch (error) {
        await Auth.signOut();
        navigate("/");
      }
    };

    checkUser();
  }, [navigate]);

  const handleSubmit = () => {
    setModal({
      show: true,
      type: "warning",
      title: "Are you sure?",
      message: "Do you want to Sign Out?",
      isConfirm: true,
      onConfirm: confirmLogout,
      onCancel: () => setModal((prev) => ({ ...prev, show: false })),
    });
  };

  const handleModalClose = () => {
    const action = modal.nextAction;
    setModal((prev) => ({ ...prev, show: false, nextAction: null }));
    if (action) action();
  };

  const confirmLogout = () => {
    setModal((prev) => ({ ...prev, show: false }));
    setModal({
      show: true,
      type: "success",
      title: "Success!",
      message: "Signed out successfully.",
      autoClose: 6000,
      nextAction: () => {
        Signout();
      },
    });
  };

  const toggleDropdown = () => {
    setIsDropdownVisible((prev) => !prev);
    setIsArrowDown((prev) => !prev);
    setIsNotificationDropdownVisible(false); // Hide notification dropdown
  };

  const clientnav = () => {
    navigate("/my-clients");
  };
  const homenav = () => {
    navigate("/amtpl");
  };
  const procurementnav = () => {
    // window.open("/amtpl-procurement", "_blank");
    navigate("/amtpl-procurement");
  };

  useEffect(() => {
    const handleClickOutside = (event) => {
      if (dropdownRef.current && !dropdownRef.current.contains(event.target)) {
        setIsDropdownVisible(false);
        setIsArrowDown(true);
        setIsNotificationDropdownVisible(false);
        setIsProfileDropdownVisible(false);
      }
    };

    document.addEventListener("mousedown", handleClickOutside);
    return () => {
      document.removeEventListener("mousedown", handleClickOutside);
    };
  }, []);

  useEffect(() => {
    const checkUserMessageCount = async () => {
      try {
        if (!activeUser) return; // Wait for activeUser to be set
        const msgResponse = await fetchData({
          target: "listMessages",
          userOrder: "CreatedAt",
          orderDirection: "ASC",
          rowStart: 0,
          pageSize: 1000,
          filterTerms: {
            ReceiverUserID: activeUser,
            IsRead: 0,
          },
        });
        console.log("msgResponse", msgResponse.total);
        setUserMessageCount(msgResponse.total || 0); // Set to 0 if total is undefined
      } catch (error) {
        console.error("Error fetching message count:", error);
        setUserMessageCount(0); // Fallback to 0 on error
      }
    };

    checkUserMessageCount();
  }, [activeUser]); // Depend on activeUser, not userMessageCount

  const redirectToMessage = () => {
    navigate("/amtpl/messaging");
  };

  const toggleProfileDropdown = () => {
    setIsProfileDropdownVisible((prev) => !prev);
    setIsNotificationDropdownVisible(false); // Hide notification dropdown
  };

  return (
    <div className="header">
      <AlertModal
        type={modal.type}
        title={modal.title}
        message={modal.message}
        showModal={modal.show}
        onClose={handleModalClose}
        onConfirm={modal.onConfirm}
        onCancel={modal.onCancel}
        isConfirm={modal.isConfirm}
        buttonText="OK"
        autoClose={modal.autoClose}
      />
      <header>
        <div className="header-cus">
          <img
            src="/images/logo.png"
            alt="Grains Global Logo"
            className="logo"
          />
        </div>
        <div className="diplay-flex-css">
          <div className="breadcumbs">{/* <Breadcrumbs /> */}</div>
          <nav>
            <ul>
              <li ref={dropdownRef} className="profile-menu">
                <div
                  className="profile-trigger"
                  style={{
                    display: "flex",
                    alignItems: "center",
                    position: "relative",
                  }}
                >
                  <Badge
                    badgeContent={
                      userMessageCount > 0 ? userMessageCount : null
                    } // Only show badge if count > 0
                    color="error"
                    onClick={redirectToMessage}
                    style={{ marginRight: "15px" }}
                  >
                    <MessageIcon
                      style={{ width: "20px", color: "#4c4949da" }}
                    />
                  </Badge>

                  {/* Real-time notification system */}
                  <div
                    style={{
                      marginRight: "15px",
                      display: "flex",
                      alignItems: "center",
                      position: "relative",
                    }}
                  >
                    <NotificationCenter size="medium" />
                  </div>
                  <div
                    onClick={toggleDropdown}
                    style={{
                      marginLeft: "10px",
                      display: "flex",
                      alignItems: "center",
                    }}
                  >
                    <PersonIcon style={{ width: "20px", color: "#4c4949da" }} />
                    {activeUser}
                    {isDropdownVisible ? (
                      <ExpandLessIcon />
                    ) : (
                      <ExpandMoreIcon />
                    )}
                  </div>
                </div>
                {isDropdownVisible && (
                  <div className="profile-dropdown">
                    <div className="dropdown-content">
                      {clientmenu ? (
                        <>
                          <button onClick={clientnav} className="dropdown-item">
                            <PersonIcon /> My Client
                          </button>
                          <div className="border-1"></div>
                        </>
                      ) : (
                        ""
                      )}
                      {homemenu ? (
                        <>
                          <button onClick={homenav} className="dropdown-item">
                            <PersonIcon /> Trade
                          </button>
                          <div className="border-1"></div>
                        </>
                      ) : (
                        ""
                      )}
                      {procurementmenu ? (
                        <>
                          <button
                            onClick={procurementnav}
                            className="dropdown-item"
                          >
                            <PersonIcon /> Procurement
                          </button>
                          <div className="border-1"></div>
                        </>
                      ) : (
                        ""
                      )}
                      <button onClick={handleSubmit} className="dropdown-item">
                        <ExitToAppIcon /> Sign Out
                      </button>
                    </div>
                  </div>
                )}
              </li>
            </ul>
          </nav>
        </div>
      </header>
    </div>
  );
};

export default Header;
